import { render, staticRenderFns } from "./NavSolutionBlock.vue?vue&type=template&id=79a1e8ca&scoped=true&"
import script from "./NavSolutionBlock.vue?vue&type=script&lang=js&"
export * from "./NavSolutionBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a1e8ca",
  null
  
)

export default component.exports